var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.orgRoleIsPermitted(_vm.$orgRoles.CUSTOMER_FL44)
        ? _c(
            "b-dropdown",
            {
              attrs: {
                disabled: _vm.isDataSending,
                variant: "custom-green",
                right: "",
                text: "Выгрузки",
              },
            },
            [
              _c(
                "b-dropdown-item",
                {
                  attrs: {
                    disabled: _vm.isDataSending,
                    "link-class": "grey-color fs-14",
                  },
                  on: {
                    click: function ($event) {
                      _vm.showContractsExportModal = true
                    },
                  },
                },
                [_vm._v("Реестр контрактов")]
              ),
              _c(
                "b-dropdown-item",
                {
                  attrs: {
                    disabled: _vm.isDataSending,
                    "link-class": "grey-color fs-14",
                  },
                  on: { click: _vm.downloadPostReport },
                },
                [_vm._v("Пост-отчет по закупкам малого объёма")]
              ),
              _c(
                "b-dropdown-item",
                {
                  attrs: {
                    disabled: _vm.isDataSending,
                    "link-class": "grey-color fs-14",
                  },
                  on: {
                    click: function ($event) {
                      _vm.showDeliverablesByYearExportModal = true
                    },
                  },
                },
                [_vm._v("Реестр закупленных ТРУ за год")]
              ),
            ],
            1
          )
        : _c(
            "b-button",
            {
              staticClass: "text-uppercase",
              staticStyle: { height: "32px", "line-height": "15px" },
              attrs: { disabled: _vm.isDataSending, variant: "custom-green" },
              on: {
                click: function ($event) {
                  _vm.showContractsExportModal = true
                },
              },
            },
            [_vm._v("Реестр контрактов")]
          ),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-header-close": "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            title: "Реестр контрактов",
            size: "lg",
          },
          model: {
            value: _vm.showContractsExportModal,
            callback: function ($$v) {
              _vm.showContractsExportModal = $$v
            },
            expression: "showContractsExportModal",
          },
        },
        [
          _c("form-row-edit-date", {
            attrs: {
              label: "Дата заключения контракта, С",
              "label-cols-sm": 6,
              "label-cols-lg": 6,
              "max-date": _vm.exportContractsRequest.toContractDate,
            },
            model: {
              value: _vm.exportContractsRequest.fromContractDate,
              callback: function ($$v) {
                _vm.$set(_vm.exportContractsRequest, "fromContractDate", $$v)
              },
              expression: "exportContractsRequest.fromContractDate",
            },
          }),
          _c("form-row-edit-date", {
            attrs: {
              label: "Дата заключения контракта, По (включительно)",
              "label-cols-sm": 6,
              "label-cols-lg": 6,
              "min-date": _vm.exportContractsRequest.fromContractDate,
            },
            model: {
              value: _vm.exportContractsRequest.toContractDate,
              callback: function ($$v) {
                _vm.$set(_vm.exportContractsRequest, "toContractDate", $$v)
              },
              expression: "exportContractsRequest.toContractDate",
            },
          }),
          _c("form-row-select-multiple", {
            attrs: {
              label: "Типы закупок",
              options: _vm.$globalDictionaries.orderTypes,
              "label-field": "title",
            },
            model: {
              value: _vm.exportContractsRequest.orderType,
              callback: function ($$v) {
                _vm.$set(_vm.exportContractsRequest, "orderType", $$v)
              },
              expression: "exportContractsRequest.orderType",
            },
          }),
          _c("form-row-edit-radio", {
            attrs: {
              label: "Типы контрактов",
              options: _vm.radioOptions,
              stacked: "",
            },
            model: {
              value: _vm.exportContractsRequest.type,
              callback: function ($$v) {
                _vm.$set(_vm.exportContractsRequest, "type", $$v)
              },
              expression: "exportContractsRequest.type",
            },
          }),
          _c(
            "div",
            {
              staticClass: "w-100 text-right",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer",
            },
            [
              _c(
                "b-overlay",
                {
                  staticClass: "d-inline-block",
                  attrs: {
                    show: _vm.isDataSending,
                    opacity: "0.6",
                    rounded: "",
                    "spinner-small": "",
                    "spinner-variant": "primary",
                  },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "text-uppercase mr-2",
                      attrs: { variant: "custom-outline-secondary" },
                      on: { click: _vm.handleContractsExportCancel },
                    },
                    [_vm._v("Отмена")]
                  ),
                ],
                1
              ),
              _c(
                "b-overlay",
                {
                  staticClass: "d-inline-block",
                  attrs: {
                    show: _vm.isDataSending,
                    opacity: "0.6",
                    rounded: "",
                    "spinner-small": "",
                    "spinner-variant": "primary",
                  },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "text-uppercase",
                      attrs: { variant: "custom-green" },
                      on: { click: _vm.handleContractsExportAccept },
                    },
                    [_vm._v("Выгрузить")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-header-close": "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            title: "Реестр закупленных ТРУ за год",
            size: "lg",
          },
          model: {
            value: _vm.showDeliverablesByYearExportModal,
            callback: function ($$v) {
              _vm.showDeliverablesByYearExportModal = $$v
            },
            expression: "showDeliverablesByYearExportModal",
          },
        },
        [
          _c("form-row-single-select", {
            attrs: {
              label: "Год формирования выгрузки",
              "label-cols-sm": 6,
              "label-cols-lg": 6,
              options: _vm.getYears(),
              "label-field": "year",
              "track-by": "year",
            },
            model: {
              value: _vm.exportDeliverablesByYearRequest.year,
              callback: function ($$v) {
                _vm.$set(_vm.exportDeliverablesByYearRequest, "year", $$v)
              },
              expression: "exportDeliverablesByYearRequest.year",
            },
          }),
          _c(
            "div",
            {
              staticClass: "w-100 text-right",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer",
            },
            [
              _c(
                "b-overlay",
                {
                  staticClass: "d-inline-block",
                  attrs: {
                    show: _vm.isDataSending,
                    opacity: "0.6",
                    rounded: "",
                    "spinner-small": "",
                    "spinner-variant": "primary",
                  },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "text-uppercase mr-2",
                      attrs: { variant: "custom-outline-secondary" },
                      on: { click: _vm.handleDeliverablesByYearCancel },
                    },
                    [_vm._v("Отмена")]
                  ),
                ],
                1
              ),
              _c(
                "b-overlay",
                {
                  staticClass: "d-inline-block",
                  attrs: {
                    show: _vm.isDataSending,
                    opacity: "0.6",
                    rounded: "",
                    "spinner-small": "",
                    "spinner-variant": "primary",
                  },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "text-uppercase",
                      attrs: { variant: "custom-green" },
                      on: { click: _vm.handleDeliverablesByYearAccept },
                    },
                    [_vm._v("Выгрузить")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }